module.exports = __webpack_public_path__ + "img/Lower Man Power Color.a2efdd40.svg";